const api = {
  // 登录注册相关&公用组件
  common: {
    updatePwdByOldPwd: '/admin/right/login/updateAccountPwdByOldPwd', //通过老密码修改密码
    POST_LOGIN: '/admin/right/login/login', //登陆
    CHECK_ACCOUNT: '/admin/right/login/forgetPwdStep1', //忘记密码第一步
    SET_NEW_PASSWORD: '/admin/right/login/forgetPwdStep2', //忘记密码第二步
    POST_REGISTER: '/admin/right/register/register', //注册
    GET_LOGOUT: '/admin/right/login/logout', //退出
    GET_GENERATE_IMAGE_CODE: '/admin/right/login/generateImageCode', //获取验证码

    UPLOAD_SINGLE_FILE: '/basic/file/upload', // 上传单个文件
    UPLOAD_MULTIPLE_FILE: '/basic/file/batchUpload', // 上传多个文件
    UPLOAD_MULTIPLE_FILE_NEW: '/basic/new/file/batchUpload', // 上传多个文件 --新
    UPLOAD_SINGLE_FILE_NEW: '/basic/new/file/upload', // 上传单个文件 --新
    DEL_SINGLE_FILE: '/basic/new/file/delete', //删除单个文件

    SEND_SMS_CODE: '/admin/supplier/send-sms-code', // 发送短信验证码
    PWD_SEND_SMS_CODE: '/admin/right/login/forget-pwd/send-sms-code', // 忘记密码发送短信验证码
  },

  goodsDetail: {
    // GET_GOODS_DETAIL: '/product/facade/goods/block/getBasicInfo', // 商品详情
    GET_GOODS_DETAIL: '/fleshopy/admin/site/site-goods/getGoodsDetail', // 商品详情
    GET_GOODS_SALE_INFO: '/product/facade/goods/block/getSalesInfo', // 商品销售信息
    GET_FREIGHT_INFO: '/basic/freight-template/get', // 获取运费模板详情
    GET_FREIGHT: '/admin/basic/memberFreightTemplate/calculateSingleFreight', // 计算运费
    GET_THIRD_STOCK: '/supplier/product/listSupplierStock', // 获取第三方库存
  },

  goods: {
    GET_BASE_GOODS_LIST: '/admin/product/goods/search/getSupplyList', // 基础商品列表
    GET_POOL_GOODS_LIST: '/admin/product/goods/search/getPoolGoodsList', // 商品池商品列表
    APPROVE_SINGLE_GOODS: '/admin/product/goods/search/approve', // 通过单个商品
    BATCH_APPROVE_GOODS: '/admin/product/goods/search/approveBatch', // 批量通过商品
    REJECT_SINGLE_GOODS: '/admin/product/goods/search/reject', // 驳回单个商品
    BATCH_REJECT_GOODS: '/admin/product/goods/search/rejectBatch', // 批量驳回商品
    BATCH_PICK_GOODS: '/admin/product/pool/goods/pickGoodsToPoolBatch', // 批量挑选商品上架
    BATCH_SET_VIP_PRICE: '/admin/product/goods/level/batchSetMemberLevelPrice', // 批量设置会员价
    BATCH_SET_GOODS_TAG: '/admin/product/goods/tag/relevanceGoodsTag', // 批量设置商品标签
    BATCH_UP_GOODS: '/admin/product/pool/goods/onlineShelfBatch', // 批量上架商品
    BATCH_DOWN_GOODS: '/admin/product/pool/goods/offShelfBatch', // 批量下架商品
    REMOVE_GOODS: '/admin/product/pool/goods/remove', // 移除单个商品
    BATCH_REMOVE_GOODS: '/admin/product/pool/goods/removeBatch', // 批量移除商品

    GET_GOODS_GROUP_LIST: '/admin/product/goods/group/getListByPage', // 获取商品组列表
    ADD_GOODS_GROUP: '/admin/product/goods/group/add', // 创建商品组
    UPDATE_GOODS_GROUP: '/admin/product/goods/group/update', // 更新商品组
    DEL_GOODS_GROUP: '/admin/product/goods/group/remove', // 删除商品组
    GET_GOODS_GROUP_INFO: '/admin/product/goods/group/getInfo', // 获取商品组信息
    GET_GOODS_GROUP_COMPANYS: '/admin/product/goods/group/getCompanyList', // 获取商品组企业列表
    GET_GOODS_GROUP_GOODS: '/admin/product/goods/group/getGoodsList', // 获取商品组商品列表
    GET_PLAT_GOODS: '/admin/goods/poolPlat/plat', // 获取商品库列表
    REMOVE_PlAT_GOODS: '/admin/goods/poolPlat/removeBatch', // 删除商品库商品
    OFF_SHELF_BATCH: '/admin/goods/poolPlat/offShelfBatch', // 下架商品库商品
    ONLINE_SHELF_BATCH: '/admin/goods/poolPlat/onlineShelfBatch', // 下架商品库商品
    POST_CATEGORYID_LIST: '/bestgift/goods/category/getTree',//分类树列表
    POST_GET_SEARCH: "/bestgift/member/employee/employees/search", // 根据搜索 - 员工列表
    GETSUPPLIERLIST: '/bestgift/goods/supplier/getSupplierList', //商品库 审核变更 的说书供应商接口
    poolDistSearch:"/admin/goods/poolDistSearch/dist", //分销商品池
    poolPlatPick:"/admin/goods/poolPlat/pick", //【单个】商品分销
  },

  // 商品管理
  shop: {
    // 商品
    GET_ADDRESS: '/basic/area/areas', // 获取地址库
    GET_STOCKS: '/admin/product/third/searchStock', // 获取库存

    // 审核商品商品库
    GET_JD_STORE_LIST: '/admin/product/goods/search/getJdListChoose', // 获取京东商品库-列表
    GET_SELF_STORE_LIST: '/admin/product/goods/search/getSelfListChoose', // 获取自营商品库-列表
    // GET_NEW_MARKET_PRICE: "/admin/jd/getMarketPrice", // 弹窗-获取实时市场价
    GET_NEW_MARKET_PRICE: '/admin/jn/getMarketPrice', // 弹窗-获取实时市场价
    // GET_NEW_MARKET_PRICE_MUL: "/admin/jd/syncMarketPrice", // 弹窗-获取实时市场价
    GET_NEW_MARKET_PRICE_MUL: '/admin/jn/syncMarketPrice', // 弹窗-获取实时市场价

    GET_JD_PRICE_RULE: '/admin/product/goods/pick/getApiToShopEcho', // 弹窗-获取单个京东商品价格回显信息
    GET_SELF_PRICE_RULE: '/admin/product/goods/pick/getSelfToShopEcho', // 弹窗-获取单个自营商品价格回显信息
    SEND_JD_PRICE_RULE: '/admin/product/goods/pick/apiToShop', // 挑选京东商品-提交改价
    SEND_SELF_PRICE_RULE: '/admin/product/goods/pick/selfToShopBatch', // 挑选自营商品-提交改价

    // 已挑选到象铺商品库
    GET_ELESTORE_JD_LIST: '/admin/product/goods/search/getJdListShop', // 获取京东商品库-列表
    GET_ELESTORE_SELF_LIST: '/admin/product/goods/search/getSelfListShop', // 获取自营商品库-列表

    REJECT_PRODUCT: '/admin/product/pool/rejectBatch', // 驳回商品
    SET_PRODUCT_ONSALE: '/admin/product/pool/goods/onlineShelfBatch', // 上架商品
    SET_PRODUCT_OFFSALE: '/admin/product/pool/goods/offShelfBatch', // 下架商品
    DEL_PRODUCT: '/admin/product/pool/goods/removeBatch', // 删除商品

    // 象铺商品列表
    GET_ELESTORE_SHOP_LIST: '/admin/product/goods/search/getShopList', // 获取象铺商品库-列表
    SET_ELESTORE_GOODS_ONSALE: '/admin/product/goods/search/approveBatch', // 上架商品
    SET_ELESTORE_GOODS_OFFSALE: '/admin/product/goods/search/rejectBatch', // 下架商品
    GET_ELESTORE_SHOP_SEARCH_LIST: '/admin/member/shop/shops/search/v2', // 根据商铺名称搜索商铺列表V2

    // // 卡券商城商品库
    // GET_JD_CARD_STORE_LIST: '/admin/product/search/card/searchJdPutaway', // 获取卡券京东商品库-列表
    // GET_SELF_CARD_STORE_LIST: '/admin/product/search/card/searchSelfPutaway', // 获取卡券自营商品库-列表
    // SET_CARD_PRODUCT_ONSALE: '/admin/product/card/onlineShelfBatch', // 上架商品
    // SET_CARD_PRODUCT_OFFSALE: '/admin/product/card/offShelfBatch', // 下架商品
    // DEL_CARD_PRODUCT: '/admin/product/card/removeBatch', // 删除商品

    // 信息变更审核
    GET_INFO_CHANGE_LIST: '/admin/product/goods/change/getList', // 获取信息变更列表
    GET_INFO_CHANGE_DETAIL: '/admin/product/goods/change/info', // 获取信息变更详情
    PASS_INFO_CHANGE: '/admin/product/goods/change/pass', // 通过信息变更
    REJECT_INFO_CHANGE: '/admin/product/goods/change/reject', // 驳回信息变更

    // 分类
    // GET_CATE_LIST: "/admin/product/category/getTreeListPage", // 获取root分类列表
    // GET_ROOT_CATE_LIST: "/admin/product/category/getTreeListPage", // 获取root分类列表
    // GET_SUB_CATE_LIST: "/admin/product/category/getTreeListPage", // 获取子分类列表
    GET_CATE_LIST: '/admin/goods/category/getTreePage', // 获取root分类列表
    GET_ROOT_CATE_LIST: '/admin/goods/category/getTreePage', // 获取root分类列表
    GET_SUB_CATE_LIST: '/admin/goods/category/getTreePage', // 获取子分类列表
    GET_CATE_TREE: '/admin/goods/category/getTreePage', // 获取分类树
    ADD_CATE: '/admin/goods/category/add', // 新增分类
    EDIT_CATE: '/admin/goods/category/update', // 编辑分类
    DEL_CATE: '/admin/goods/category/remove', // 删除分类
    GET_CATE_GOOGS_NUM: '/admin/goods/category/getCategoryGoodsCount', // 获取分类下的商品数
    CHANGE_CATE_SORT: '/admin/goods/category/updateSort', // 改变分类排序值

    // 品牌
    GET_BRAND_LIST: '/admin/goods/brand/getListPage', // 获取品牌列表
    ADD_BRAND: '/admin/goods/brand/add', // 新增品牌
    EDIT_BRAND: '/admin/goods/brand/update', // 编辑品牌
    DEL_BRAND: '/admin/goods/brand/remove', // 删除品牌
    GET_BRAND_GOOGS_NUM: '/admin/goods/brand/getBrandGoodsCount', // 获取品牌下的商品数

    // 标签
    GET_GOODS_TAG_TYPE_LIST: '/admin/product/goods/tag/getList', // 商品一级标签列表
    ADD_GOODS_TAG: '/admin/product/goods/tag/add', // 添加商品标签
    UPDATE_GOODS_TAG: '/admin/product/goods/tag/update', // 编辑商品标签
    DELETE_GOODS_TAG: '/admin/product/goods/tag/remove', // 删除商品标签
    CHANGE_GOODS_TAG_SORT: '/admin/product/goods/tag/updateSort', // 修改商品标签排序
    GET_GOODS_TAG_LIST: '/admin/product/goods/tag/getListByPage', // 商品标签列表
    GET_GOODS_TAG_TREE: '/admin/product/goods/tag/getTreeList', // 获取商品标签树
    GET_TAG_LIST_BY_ID: '/admin/product/goods/tag/getGoodsTagList', // 根据商品id查询对应标签

    //JD

    // POST_GET_JD_GOODS_LIST: "/supplier/jd/listSelectProduct", //获取京东商品列表
    POST_GET_JD_GOODS_LIST: '/supplier/jn/listSelectProduct', //获取京东商品列表
    // POST_UPDATE_JD_GOODS_MARKET_PRICE: "/supplier/jd/getMarketPrice", //爬取京东商品市场价
    POST_UPDATE_JD_GOODS_MARKET_PRICE: '/supplier/jn/getMarketPrice', //爬取京东商品市场价
    // POST_UPDATE_JD_GOODS_LIST_MARKET_PRICE: "/supplier/jd/syncMarketPrice", //同步京东商品市场价
    POST_UPDATE_JD_GOODS_LIST_MARKET_PRICE: '/supplier/jn/syncMarketPrice', //同步京东商品市场价
    POST_PICK_JD_GOODS: '/admin/product/standard/jd', //挑选京东商品
    // GET_JD_CATEGORY: "/supplier/jd/listCategory", //京东商品分类
    GET_JD_CATEGORY: '/supplier/jn/listCategory', //京东商品分类
    // GET_JD_LOCATION: "/supplier/jd/listArea", //京东商品地区
    GET_JD_LOCATION: '/supplier/jn/listArea', //京东商品地区
    POST_GET_JD_PICKED_LIST: '/admin/product/goods/search/getPoolGoodsList', //已挑选至SAAS京东商品列表
    POST_GET_PICKED_STOCK: '/admin/product/stock/getStockJdBatch', //获取已挑选商品精准库存
    POST_UP_JD_SAAS_GOODS: '/admin/product/pool/goods/onlineShelfBatch', //批量上架SAAS京东商品
    POST_DOWN_JD_SAAS_GOODS: '/admin/product/pool/goods/offShelfBatch', //批量下架SAAS京东商品
    POST_REFUSE_JD_SAAS_GOODS: '/admin/product/goods/search/rejectBatch', //批量驳回SAAS京东商品

    POST_GET_JD_INFO: '/admin/product/goods/pick/getJdEcho', //已挑选的京东商品信息回显
  },

  // 订单管理
  order: {
    GET_ORDER_LIST: '/admin/order/listByPage', // 获取订单列表
    GET_ORDER_DETAIL: '/admin/order/getOrderDetails', // 获取订单详情
    SEND_CONFIRM_ORDER: '/admin/order/confirmOrder', // 继续下单确认
    GET_LOGISTICS_LIST: '/basic/express/queryLogisticByExpressNo', // 获取物流信息
    GET_REFUND_LIST: '/admin/order/refund/listByPage', // 售后工单列表
    GET_REFUND_DETAIL: '/admin/order/refund/detail', // 获取售后工单详情

    GET_CARD_ORDER_LIST: '/admin/order/listSassOrderByPage', // 获取订单列表
    GET_CARD_ORDER_DETAIL: '/admin/order/getSaasOrderDetails', // 获取订单详情
    GET_ORDER_CARD_DETAIL: '/card/coupon/cus/getByOrderNo', // 获取订单-卡券信息
  },

  // 供应商管理
  supplier: {
    GET_SUPPLIER_LIST: '/admin/supplier/listByPage', // 获取供应商列表
    GET_SUPPLIER_DETAIL: '/admin/supplier/get', // 获取供应商详情
    CHANGE_SUPPLIER_STATE: '/admin/supplier/updateStatus', // 更改供应商启用状态
    ADD_SUPPLIER: '/admin/supplier/add', // 添加供应商
    EDIT_SUPPLIER: '/admin/supplier/update', // 编辑供应商
    CHECK_ACCOUNT: '/admin/supplier/checkAccount', // 校验账号

    CHECK_MOBILE: '/admin/supplier/check-mobile', // 校验供应商手机号
    GET_SUPPLIER_LIST_BY_NAME: '/admin/supplier/short-names/page', // 供应商简称列表
    GET_COMPANY_LIST_BY_NAME: '/admin/member/company/company-names', // 企业列表
    CHECK_SUPPLIER_ACCOUNT: '/admin/supplier/checkAccount', //校验供应商账号
  },

  //用户管理
  userManagement: {
    GET_AUTHEN_LIST: '/admin/member/company/certification-infos', //查询认证列表
    GET_CHECK_INFO: '/admin/member/company/certification-info', //查看认证详情
    SET_CHECK: '/admin/member/company/certification-info/audit', //审核
    GET_MEMBER_LIST: '/admin/member/company/companys/multy-condition',
  },

  // 财务管理
  finance: {
    QUERTY_TRADE: '/admin/balance/bill/queryTrade', //查询交易明细（支持供应商或会员，根据用户类型区分
    GET_INVOICE_INFO: '/balance/invoice/getFxInvoiceInfo', // 获取开票信息
    EDIT_INVOICE_INFO: '/balance/invoice/updateFxInvoiceInfo', // 提交开票信息
    QUERY_COMPANY_INFO: '/admin/balance/bill/queryCompanyInfo',
    QUERY_TRADE_AMOUNT: '/admin/balance/bill/queryTradeAmount',
    QUERY_BALANCE_PAGE: '/admin/balance/bill/queryBalancePage', // 供应商结算审核列表
    QUERY_BILL: '/balance/admin/get',
    QUERY_DETAIL_BY_BALANCEID: '/balance/admin/queryPageInvoiceGoods', // 查询结算单商品明细（开票明细)
    EXPORT_BALANCE_PDF: '/balance/admin/exportLatestSuccessBill',
    QUERY_LATEST_TEN: '/balance/admin/queryLatestSuccessBill',
    AUDIT_BILL: '/balance/admin/auditBill', // 结算审核 提交
    QUERY_ASS_BALANCEID: '/balance/admin/queryPageOrderGoods', // 查询结算单关联订单明细
    EXPORT_BALANCE_EXCEL: '/balance/admin/exportInvoiceGoods',
    EXPORT_ORDER_EXCEL: '/balance/admin/exportOrderGoods',
    GET_LOGISTICS: '/basic/express/queryLogistic',
    EXPRESS_LIST: '/basic/express/list',
    JD_INVOICE_LIST: '/supplier/jd-invoice/queryApplyPageList', //京东发票管理
    // JD_ORDER_LIST: "/supplier/jd/order/listJdChildOrder", //京东订单list
    JD_ORDER_LIST: '/supplier/jn/order/listJdChildOrder', //京东订单list
    JD_CHILDLIST: '/supplier/jd-invoice/queryApplyItemPageList', //子订单列表
    JD_DETAIAL_LIST: '/supplier/jd-invoice/queryInvoicePageList', //发票明细list
    JD_INVOICE_GOODS_LIST: '/supplier/jd-invoice/querySkuPageList', //发票内商品明细

    // 会员结算管理
    GET_VIP_INVOICE_LIST: '/balance/admin/invoice/queryPageInvoice', // 会员发票管理
    GET_VIP_INVOICE_DETAIL: '/balance/admin/invoice/get', // 会员发票详情
    AUDIT_VIP_INVOICE: '/balance/admin/invoice/auditInvoice', // 会员开票审核
    GET_INVOICE_GOODS_LIST: '/balance/admin/invoice/queryPageInvoiceGoods', // 开票商品明细
    EXPORT_INVOICE_GOODS: '/balance/admin/invoice/exportInvoiceGoods', // 导出开票商品
    GET_TRADE_LIST: '/balance/admin/trade/serial', // 交易明细（供应商、商家、会员）
    GET_TRADE_AMOUNT: '/balance/admin/trade/amount', // 金额统计
    GET_SMS_LIST: '/admin/member/sms-signature/sms-signature-list/multi-condition', // 短信签名审核列表
    SEND_SMS: '/admin/member/sms-signature/test', // 发放短信签名
    PASS_SMS: '/admin/member/sms-signature/pass', // 通过短信签名
    REFUSE_SMS: '/admin/member/sms-signature/reject', // 驳回短信签名
    DELETE_SMS: '/admin/member/sms-signature/delete', // 删除短信签名
    GET_CAST_OUT_LIST: '/balance/admin/trade/cash/queryPage', // 提现审核列表
    CASH_AUDIT: '/balance/admin/trade/cash/audit', // 提现审核

    // 结算审核
    GET_SETTLEMENT_LIST: '/balance/admin/billPage', // 结算审核列表（供应商、商家）
    GET_COMPANY_LIST: '/balance/admin/queryPageCompany', // 查询企业列表

    // 对账功能
    GET_INTERNAL_LIST: '/admin/check/findDifferentList', //内部对账
    GET_EXTERNAL_LIST: '/admin/check/findThirdList', //外部对账
    GET_STATEMENT_LIST: '/admin/pay/channel/cmb/detail/list', //招行流水列表
    GET_STATEMENT_DETAIL: '/admin/pay/channel/cmb/detail/get', //招行流水详情
  },

  // 营销活动营运
  activity: {
    GET_ACTIVITY_LIST: '/admin/activity/meetingRight/selectActivityList', // 获取权益包活动列表
    ADD_ACTIVITY: '/admin/activity/meetingRight/createActivity', // 创建权益包活动
    UPDATE_ACTIVITY: '/admin/activity/meetingRight/updateActivity', // 编辑权益包活动
    GET_ACTIVITY_DETAIL: '/admin/activity/meetingRight/selectActivityInfo', // 获取权益包活动详情
    GET_PACK_DETAIL: '/admin/activity/meetingRight/showActivityInfo', // 获取权益包详情
    GET_PACK_GOODS: '/admin/activity/meetingRight/selectActivityGoods', // 获取包商品列表
    ADD_GOODS: '/admin/activity/meetingRight/addActivityGoods', // 添加活动商品
    REMOVE_GOODS: '/admin/activity/meetingRight/delActivityGoods', // 移除商品
    SET_PACK_LEVEL: '/admin/activity/meetingRight/updateActivityLevel', // 多品包、品牌包设置档位
    SET_GOODS_DISCOUNT: '/admin/activity/meetingRight/updateActivityDiscount', // 设置商品折扣
    GET_ACTIVITY_ORDER: '/admin/order/equity/listByPage', // 获取活动订单
    VALE_PAY: '/admin/order/equity/valetPay', // 活动订单-代客支付
    GET_ACTIVITY_ORDER_PAY_INFO: '/admin/order/equity/getValetPayInfo', // 活动订单-支付详情
    GET_ACTIVITY_STAT_DATA: '/admin/order/equity/getEquityPackageStat', // 活动数据
  },

  // 运营
  operate: {
    GET_NEW_THREE_PRICE: '/admin/member/product/member-level-price/get', //新的3.0价格获取接口
    ADD_FLOOR_HOME: '/elebuys/floor/add-topic-floor', //增加pc首页专题楼层
    DEL_SPECIAL_TO_SPECIAL_FLOOR: '/elebuys/floor/remove-topic', //删除专题
    ADD_SPECIAL_TO_SPECIAL_FLOOR: '/admin/elebuys/floor/add-topic', //专题楼层添加专题
    CHECK_SUPPLIER_ACCOUNT_ELEMENT: '/admin/member/shop/check-account', //校验象铺供应商账号
    GET_SUPPLIER_INFO: '/admin/member/company/user', //象铺获取卖家会员信息
    // 礼业采销通
    GET_PRODUCT_TYPE_LIST: '/procurement/category/listAll', // 获取产品类型列表
    GET_LIYE_INFO_LIST: '/procurement/items/listByPage', // 获取信息列表
    DEL_LIYE_INFO: '/procurement/items/remove', // 删除信息
    SET_TOP_LIYE_INFO: '/procurement/items/setTop', // 置顶信息
    SET_LABEL_TYPE: '/procurement/items/updateLabelType', // 设置标签类型
    GET_LIYE_QACODE: '/procurement/items/getQRCode', // 获取小程序二维码

    GET_LIYE_INFO_DETAIL: '/procurement/items/getDetails', // 获取信息详情
    GET_LIYE_INFO_COMMENT_LIST: '/procurement/reply/listReplyByPage', // 获取评论列表
    GET_LIYE_INFO_BROWSE_LIST: '/procurement/browse/log/listByPage', // 获取浏览记录列表

    GET_LIYE_BANNER_LIST: '/procurement/pics/listAll', // 获取轮播图列表
    ADD_BANNER: '/procurement/pics/save',
    EDIT_BANNER: '/procurement/pics/update',
    DEL_BANNER: '/procurement/pics/remove',

    GET_LIYE_INFO_TYPE_LIST: '/procurement/category/listCategory', // 获取信息类型列表
    ADD_INFO_TYPE: '/procurement/category/save',
    EDIT_INFO_TYPE: '/procurement/category/update',
    CHANGE_INFO_TYPE: '/procurement/category/updateState', // 状态更新&删除
    ELE_SHOP_CHANGE_STATE: '/admin/member/shop/status/change',

    GET_USER_LIST: '/procurement/user/listByPage', // 获取用户列表
    CHANGE_USER_TYPE: '/procurement/user/updateState', // 状态更新
    GET_USER_DATA: '/procurement/data/user/selectCountGroupByDay', // 获取用户数据
    GET_INFO_DATA: '/procurement/data/item/selectCountGroupByDay', // 获取信息数据
    GET_INFO_RANK_LIST: '/procurement/data/item/getCategoryTopDataByDay', // 获取信息热度排行

    // 卡券
    GET_OPERATE_LIST: '/manager/picture/index', // 获取 卡券封面列表，以及推广海报 卡券案例等 --
    ADD_OPERATE: '/manager/picture/add', // --
    EDIT_OPERATE: '/manager/picture/edit', // --
    DEL_OPERATE: '/manager/picture/delete', // --
    CHANGE_OPERATE_STATE: '/manager/picture/online', // --
    GET_OPERATE_DETAIL: '/manager/picture/info', // --
    SET_OPERATION_SORT: '/manager/picture/sort',

    GET_LABEL_LIST: '/manager/label/get_by_parent', // 获取 标签列表
    ADD_LABEL: '/manager/label/add', // --
    EDIT_LABEL: '/manager/label/edit', // --
    DEL_LABEL: '/manager/label/delete', // --
    GET_LABEL_DETAIL: '/manager/label/info', // --

    GET_CARD_TYPE_LIST: '/manager/card_type/index', // 获取 卡券类型列表 --
    EDIT_CARD_TYPE: '/manager/card_type/select', // 设置卡券类型 --

    // 采购商城运营
    //专题
    GET_SPECIAL_LIST: '/elebuys/admin/special-topic/list', //专题列表--
    ADD_SPECIAL: '/elebuys/admin/special-topic/add-update', //添加专题--
    GET_SPECIAL_INFO: '/elebuys/admin/special-topic/get-topic-info', //获取专题信息
    DEL_SPECIAL: '/elebuys/admin/special-topic/delete', //删除专题
    SPECIAL_CHILD_ORDER: '/elebuys/admin/special-topic/update-sort', //子专题排序
    SPECIAL_GOODS: '/elebuys/admin/special-topic/get-goods', //获取专题下的商品
    UPDATE_CHILD_SPECIAL: '/elebuys/admin/special-topic/add-update-child', //添加编辑子专题
    DEL_CHILD_SPECIAL: '/elebuys/admin/special-topic/delete-child-topic', //删除子专题
    GET_GOODS: '/product/facade/admin/search/purchase/getGoodsPage', //获取商品信息
    SELECT_SPECIAL_GOODS: '/elebuys/admin/special-topic/batch-add-goods', //专题下批量挑选商品
    DEL_SPECIAL_GOODS: '/elebuys/admin/special-topic/batch-remove-goods', //专题下批量删除商品

    GET_PURCHASE_HOME_BANNER_LIST: '/elebuys/admin/ad/carousel-ad-page-query', // 首页运营-轮播图列表
    EDIT_PURCHASE_HOME_BANNER: '/elebuys/admin/ad/carousel-ad-add-update', // 首页运营-轮播图添加&编辑
    DEL_PURCHASE_HOME_BANNER: '/elebuys/admin/ad/carousel-ad-update-status', // 首页运营-轮播图显示&隐藏&删除
    CHANGE_PURCHASE_HOME_BANNER_SORT: '/elebuys/admin/ad/carousel-ad-update-sort', // 首页运营-轮播图更改排序
    GET_PURCHASE_HOME_BANNER_DETAIL: '/elebuys/admin/ad/get', // 首页运营-轮播图/广告详情

    GET_PURCHASE_HOME_MAIN_ADVERT_LIST: '/elebuys/admin/ad/main-ad-page-query', // 首页运营-主推广告列表
    EDIT_PURCHASE_HOME_MAIN_ADVERT: '/elebuys/admin/ad/main-ad-add-update', // 首页运营-主推广告添加&编辑
    DEL_PURCHASE_HOME_MAIN_ADVERT: '/elebuys/admin/ad/main-ad-update-status', // 首页运营-主推广告显示&隐藏&删除
    CHANGE_PURCHASE_HOME_MAIN_ADVERT_SORT: '/elebuys/admin/ad/main-ad-update-sort', // 首页运营-主推广告更改排序
    GET_PURCHASE_HOME_MAIN_ADVERT_INFO: '/elebuys/admin/ad/main-ad-title-get', // 首页运营-主推广告名称获取
    SET_PURCHASE_HOME_MAIN_ADVERT_INFO: '/elebuys/admin/ad/main-ad-title-set', // 首页运营-主推广告名称设置

    GET_PURCHASE_HOME_TOP_ADVERT_LIST: '/elebuys/admin/ad/top-ad-page-query', // 首页运营-顶部广告列表
    EDIT_PURCHASE_HOME_TOP_ADVERT: '/elebuys/admin/ad/top-ad-add-update', // 首页运营-顶部广告添加&编辑
    DEL_PURCHASE_HOME_TOP_ADVERT: '/elebuys/admin/ad/top-ad-update-status', // 首页运营-顶部广告显示&隐藏&删除

    GET_PURCHASE_HOME_HOT_WORD_LIST: '/elebuys/admin/hotwords/list', // 首页运营-热词列表
    EDIT_PURCHASE_HOME_HOT_WORD: '/elebuys/admin/hotwords/add', // 首页运营-热词添加
    DEL_PURCHASE_HOME_HOT_WORD: '/elebuys/admin/hotwords/change-status', // 首页运营-热词显示&隐藏&删除
    CHANGE_PURCHASE_HOME_HOT_WORD_SORT: '/elebuys/admin/hotwords/change-sort', // 首页运营-热词更改排序

    GET_PURCHASE_HOME_CHANNEL_LIST: '/elebuys/admin/channel/listByPage', // 首页运营-频道管理列表
    ADD_PURCHASE_HOME_CHANNEL: '/elebuys/admin/channel/save', // 首页运营-频道管理添加
    EDIT_PURCHASE_HOME_CHANNEL: '/elebuys/admin/channel/update', // 首页运营-频道管理编辑
    DEL_PURCHASE_HOME_CHANNEL: '/elebuys/admin/channel/updateStatus', // 首页运营-频道管理显示&隐藏&删除
    CHANGE_PURCHASE_HOME_CHANNEL_SORT: '/elebuys/admin/channel/sort', // 首页运营-频道管理更改排序
    GET_PURCHASE_HOME_CHANNEL_DETAIL: '/elebuys/admin/channel/getById', // 首页运营-轮播图/广告详情

    GET_PURCHASE_HOME_OPERATE_SHOW_NUMBER: '/elebuys/admin/ad/get-show-number', // 获取显示的记录数量-轮播/广告
    GET_PURCHASE_HOME_OPERATE_WORDS_SHOW_NUMBER: '/elebuys/admin/hotwords/get-show-number', // 获取显示的记录数量-热词
    GET_PURCHASE_HOME_OPERATE_CHANNEL_SHOW_NUMBER: '/elebuys/admin/channel/getEffectiveCount', // 获取显示的记录数量-频道

    GET_PURCHASE_HOME_FLOOR_SORT_LIST: '/elebuys/admin/floor/sort-list', // 首页运营-首页楼层排序-列表
    CHANGE_PURCHASE_HOME_FLOOR_SORT: '/elebuys/admin/floor/sort-floor', // 首页运营-楼层更改排序

    GET_PURCHASE_HOME_FLOOR_MOBILE_LIST: '/elebuys/admin/mobile-floor/list', //首页运营-手机端楼层列表展示
    GET_PURCHASE_HOME_FLOOR_MOBILE_SHOW_NUMBER: '/elebuys/admin/mobile-floor/get-show-number', //首页运营-手机端楼层展示数量
    SET_PURCHASE_HOME_FLOOR_MOBILE_SORT: '/elebuys/admin/mobile-floor/update-sort', //首页运营-排序
    SET_PURCHASE_HOME_FLOOR_MOBILE_STATUS: '/elebuys/admin/mobile-floor/update-status', //首页运营-修改状态

    // 首页运营-楼层
    GET_PURCHASE_HOME_FLOOR_DETAIL: '/elebuys/admin/floor/get-detail', // 首页运营-获取楼层详情
    GET_MOBILE_PURCHASE_HOME_FLOOR_DETAIL: '/elebuys/admin/mobile-floor/get-detail', // 首页运营-获取手机端楼层详情

    GET_PURCHASE_HOME_FLOOR_LIST: '/elebuys/admin/floor/list', // 首页运营-楼层列表
    ADD_PURCHASE_HOME_AD_FLOOR: '/elebuys/admin/floor/add-ad-floor', // 首页运营-添加广告楼层
    ADD_PURCHASE_HOME_SHOP_FLOOR: '/elebuys/admin/floor/add-goods-floor', // 首页运营-添加商品楼层
    DEL_PURCHASE_HOME_FLOOR: '/elebuys/admin/floor/update-status', // 首页运营-楼层显示&隐藏&删除

    ADD_PURCHASE_OPERATE_AD_FLOOR_MOBILE: '/elebuys/admin/mobile-floor/add-ad-floor', // 独立运营页面-添加广告楼层--手机
    ADD_PURCHASE_OPERATE_SHOP_FLOOR_MOBILE: '/elebuys/admin/mobile-floor/add-goods-floor', // 独立运营页面-添加商品楼层--手机
    ADD_PURCHASE_OPERATE_ACT_FLOOR_MOBILE: '/elebuys/admin/mobile-floor/add-activity-floor', // 独立运营页面-添加活动楼层--手机

    EDIT_MOBILE_OPERATE_FLOOR_INTRO: '/elebuys/admin/mobile-floor/update-floor', // 独立运营页面-编辑楼层简介-手机
    UPDATE_FLOOR_SORT: '/elebuys/admin/page-floor/update-sort', // 独立运营页-楼层排序

    EDIT_PURCHASE_HOME_FLOOR_INTRO: '/elebuys/admin/floor/update-floor', // 首页运营-编辑楼层简介
    ADD_GOODS_TO_SHOP_FLOOR: '/elebuys/admin/floor/add-goods', // 商品楼层添加商品
    ADD_MOBILE_GOODS_TO_SHOP_FLOOR: '/elebuys/admin/mobile-floor/add-goods', // 商品楼层添加商品--手机

    DEL_GOODS_TO_SHOP_FLOOR: '/elebuys/admin/floor/remove-goods', // 商品楼层删除商品
    CHANGE_SHOP_FLOOR_GOODS_SORT: '/elebuys/admin/floor/sort-goods', // 商品楼层商品排序
    EDIT_ADVERT_FLOOR_DETAIL: '/elebuys/admin/floor/add-ad', // 广告楼层-保存详细设置
    EDIT_MOBILE_ADVERT_FLOOR_DETAIL: '/elebuys/admin/mobile-floor/add-ad', // 广告楼层-保存详细设置 --手机

    // 独立运营页面
    GET_INDEPEND_OPERATE_LIST: '/elebuys/admin/page/list', // 独立运营页面列表
    ADD_INDEPEND_OPERATE: '/elebuys/admin/page/add', // 独立运营页面添加&编辑
    EDIT_INDEPEND_OPERATE: '/elebuys/admin/page/update', // 独立运营页面添加&编辑
    DEL_INDEPEND_OPERATE: '/elebuys/admin/page/delete', // 独立运营页面删除

    // 独立运营页面-楼层
    GET_INDEPEND_OPERATE_FLOOR_LIST: '/elebuys/admin/page-floor/list', // 独立运营页面-楼层列表
    DEL_INDEPEND_OPERATE_FLOOR: '/elebuys/admin/floor/update-status', // 独立运营页面-楼层删除
    ADD_INDEPEND_OPERATE_AD_FLOOR: '/elebuys/admin/page-floor/add-ad-floor', // 独立运营页面-添加广告楼层
    ADD_INDEPEND_OPERATE_SHOP_FLOOR: '/elebuys/admin/page-floor/add-goods-floor', // 独立运营页面-添加商品楼层

    EDIT_INDEPEND_OPERATE_FLOOR_INTRO: '/elebuys/admin/page-floor/update-floor', // 独立运营页面-编辑楼层简介

    ADD_GOODS_TO_INDEPEND_OPERATE_SHOP_FLOOR: '/elebuys/admin/page-floor/add-goods', // 独立运营页面-商品楼层添加商品
    DEL_GOODS_TO_INDEPEND_OPERATE_SHOP_FLOOR: '/elebuys/admin/page-floor/remove-goods', // 独立运营页面-商品楼层删除商品
    CHANGE_INDEPEND_OPERATE_SHOP_FLOOR_GOODS_SORT: '/elebuys/admin/page-floor/sort-goods', // 独立运营页面-商品楼层商品排序
    EDIT_INDEPEND_OPERATE_ADVERT_FLOOR_DETAIL: '/elebuys/admin/page-floor/add-ad', // 独立运营页面-广告楼层-保存详细设置

    // 工作台首页
    GET_WORK_BENCH_HOME_DETAIL: '/elebuys/admin/work-floor/get-detail', // 工作台首页-获取楼层详情
    SET_WORK_BENCH_LAYOUT: '/elebuys/admin/work-floor/add-ad-floor', // 工作台首页-设置画布
    EDIT_WORK_BENCH_HOME_DETAIL: '/elebuys/admin/work-floor/add-ad', // 工作台首页-保存详细设置

    // 精选tab
    GET_SELECT_CONFIG: '/elebuys/admin/common-config/getSelectionConfig', // 获取当前配置
    UPDATE_SELECT_CONFIG: '/elebuys/admin/common-config/setSelectionConfig', // 修改当前配置

    // 价格设置
    GET_PRICE_RANGE_LIST: '/elebuys/admin/price/priceSectionPageList', // 获取价格区间列表
    GET_PRICE_RANGE_SHOW_COUNT: '/elebuys/admin/price/getVisibleCount', // 获取价格区间显示个数
    ADD_PRICE_RANGE: '/elebuys/admin/price/addPriceSection', // 添加价格区间
    DELETE_PRICE_RANGE: '/elebuys/admin/price/removePriceSection', // 删除价格区间
    UPDATE_PRICE_RANGE_STATUS: '/elebuys/admin/price/updatePriceSectionVisible', // 修改价格区间展示状态
    UPDATE_PRICE_RANGE_SORT: '/elebuys/admin/price/updatePriceSectionSort', // 修改价格区间排序
    GET_PRICE_HOT_LIST: '/elebuys/admin/price/hotSearchPriceGet', // 获取热搜价格列表
    UPDATE_PRICE_HOT_LIST: '/elebuys/admin/price/hotSearchPriceSet', // 修改热搜价格

    //资讯管理
    GET_INFOMATION_LIST: '/elebuys/admin/article/page-list', //资讯列表
    INFOMATION_ORDER: '/elebuys/admin/article/change-sort', //资讯排序
    INFOMATION_SETTOP: '/elebuys/admin/article/change-top-status', //资讯置顶 取消置顶
    DEL_INFOMATION: '/elebuys/admin/article/delete', //资讯删除
    GET_INFOMATION_DETAIL: '/elebuys/admin/article/get', //获取资讯详情
    ADD_INFOMATION: '/elebuys/admin/article/add', //新增资讯
    UPDATE_INFOMATION: '/elebuys/admin/article/update', //编辑资讯

    //派样
    GET_SENDSAMPLE_LIST: '/admin/marketing/activity/page-list', //派样列表
    ADD_ACT: '/admin/marketing/activity/save', //新建活动
    ACT_DETAIL: '/admin/marketing/activity/get-detail', //获取活动详情
    ACT_UPDATE: '/admin/marketing/activity/update', //活动更新
    ACT_ORDER: '/admin/marketing/activity/change-sort', //排序
    ACT_STATUS: '/admin/marketing/activity/change-show-type', //显示 隐藏
    ACT_OPEN: '/admin/marketing/activity/getEffectiveCount', //查询开放活动数
    ACT_DATA: '/admin/marketing/activity/sample/participant/listByPage', //派样活动数据
    ACT_DATA_EXPORT: '/admin/marketing/activity/sample/participant/export', //派样活动数据导出
    SENDSAMPLE_GOODS: '/admin/marketing/activity/sample/goods/listByPage', //派样商品
    SENDSAMPLE_GOODS_ORDER: '/admin/marketing/activity/sample/goods/changeSort', //派样商品排序
    SENDSAMPLE_GOODS_CHECK: '/admin/marketing/activity/sample/goods/updateApprovalStatus',
    SENDSAMPLE_QUIT_ACITVITY: '/admin/marketing/activity/sample/goods/exitActivity',

    //素材
    MATERIAL_LIST: '/elebuys/admin/material/listByPage', //素材列表
    MATERIAL_LIST_ORDER: '/elebuys/admin/material/sort', //素材列表排序
    MATERIAL_DEL: '/elebuys/admin/material/updateStatus', //素材列表删除
    MATERIAL_ADD: '/elebuys/admin/material/save', //素材列表新增
    CLASSIfY_LIST: '/elebuys/admin/material/category/listAll', //素材分类列表
    MATERIAL_DETAIL: '/elebuys/admin/material/getMaterialDetails', //素材详情
    MATERIAL_UPDATE: '/elebuys/admin/material/update', //素材编辑
    CLASSIFY_SORT: '/elebuys/admin/material/category/sort', //素材分类排序
    CLASSIFY_DEL: '/elebuys/admin/material/category/remove', //素材分类删除
    CLASSIFY_ADD: '/elebuys/admin/material/category/add', //素材分类新增
    CLASSIFY_UPDATE: '/elebuys/admin/material/category/update', //素材分类更新

    // 应用市场运营
    APPLY_LIST: '/admin/app/get', //应用列表
    APPLY_MODULE_LIST: '/admin/app-module/module-list', //应用模块列表
    SET_APPLY_DETAIL: '/admin/app/detail-pic-set', //编辑应用详情
    ADD_APPLY_MODULE: '/admin/app-module/module-add', //添加自定义模块
    GET_APPLY_MODULE_DETAIL: '/admin/app-module/detail', //获取应用模块详情
    UPDATE_APPLY_MODULE: '/admin/app-module/module-update', //更新自定义模块
    DEL_APPLY_MODULE: '/admin/app-module/module-delete', //删除自定义模块
    SET_APPLY_MODULE_ORDER: '/admin/app-module/module-sort-update', //应用模块排序

    // 返点会场
    GET_ACTIVITY_PAGE_CONFIG: '/admin/marketing/activity/common/config/getConfig', // 获取活动页面配置信息
    UPDATE_ACTIVITY_PAGE_CONFIG: '/admin/marketing/activity/common/config/setConfig', // 修改活动页面配置信息
    REBATE_GET_LIST: '/admin/marketing/activity/rebate/pageList', // 返点活动列表
    REBATE_GET_DETAIL: '/admin/marketing/activity/rebate/getDetail', // 返点活动详情
    REBATE_ADD: '/admin/marketing/activity/rebate/add', // 创建返点活动
    REBATE_UPDATE: '/admin/marketing/activity/rebate/update', // 编辑返点活动
    REBATE_CHANGE_SHOW_TYPE: '/admin/marketing/activity/rebate/updateShowType', // 返点活动展示状态改变
    REBATE_CHANGE_SORT_VALUE: '/admin/marketing/activity/rebate/updateSort', // 返点活动排序修改
    REBATE_GET_AUDIT_LIST: '/admin/marketing/activity/rebate-meeting/meetingList', // 返点会场审核列表
    REBATE_PASS_SHOP: '/admin/marketing/activity/rebate-meeting/pass', // 商家报名会场审核通过
    REBATE_REFUSE_SHOP: '/admin/marketing/activity/rebate-meeting/reject', // 商家报名会场审核驳回
    REBATE_EXIT_SHOP: '/admin/marketing/activity/rebate-meeting/auditQuitApply', // 商家报名会场退出审核：退出、驳回
    REBATE_GET_SIGN_UP_DETAIL: '/admin/marketing/activity/rebate-meeting/getSignUpInfoById', // 商家报名详情
    REBATE_GET_SIGN_UP_GOODS: '/admin/marketing/activity/rebate-meeting/getSignUpGoodsById', // 商家报名商品
    REBATE_PASS_GOODS: '/admin/marketing/activity/goods/batchPass', // 报名商品通过
    REBATE_REFUSE_GOODS: '/admin/marketing/activity/goods/batchReject', // 报名商品驳回

    // 精选好店
    GET_PAGE_CONFIG: '/elebuys/operation/common-configuration/get', // 获取当前好店配置
    UPDATE_PAGE_CONFIG: '/elebuys/operation/common-configuration/add-edit', // 修改好店配置
    GET_GOOD_STORE_LIST: '/admin/member/shop/good-shop-list', // 获取好店列表
    UPDATE_GOOD_STORE: '/admin/member/shop/update-good-shop', // 编辑好店：显示、隐藏、删除
    ADD_GOOD_STORE: '/admin/member/shop/select-good-shop', // 添加好店

    // 小程序管理
    QUERY_WEAPP_LIST: '/wechat/third/admin/appList', // 小程序列表
    // 小程序主体信息
    GET_WEAPP_INFO: '/wechat/third/admin/getAppPrincipal',
    // 小程序撤回版本
    CANCEL_AUDIT: '/wechat/third/admin/cancelAudit',
    // 查看体验码
    WEAPP_QRCODE: '/wechat/third/admin/betaQrCode',
    // 绑定体验者账号
    BIND_WECHAT_USER: '/wechat/third/admin/bindUser',
    // 查询可回退历史版本
    GET_VERSION_LIST: '/wechat/third/admin/historyVersion',
    // 回滚小程序版本
    ROLLBACK_VERSION: '/wechat/third/admin/rollbackApp',
    // 小程序停用启用状态
    TOGGLE_WECHAT_STATUS: '/wechat/third/admin/setAppVisitStatus',
    // 获取审核历史记录
    GET_AUDIT_LIST: '/wechat/third/admin/auditHistory',
    // 获取草稿列表
    GET_DRAFT_LIST: '/wechat/third/admin/draftList',
    // 添加到模版库
    ADD_TEMPLATE: '/wechat/third/admin/addTemplate',
    // 查询模版列表
    GET_TEMPLATE_LIST: '/wechat/third/admin/getAllTemplate',
    // 查询模版列表byid
    GET_TEMPLATE_LIST_BYID: '/wechat/third/admin/getTemplatesByAppId',
    // 同步模版列表
    SYNC_TEMPLATE_LIST: '/wechat/third/admin/syncTemplate',
    // 编辑模版
    UPDATE_TEMPLATE: '/wechat/third/admin/updateTemplate',
    // 删除模版
    DELETE_TEMPLATE: '/wechat/third/admin/deleteTemplate',
    // 设为默认模版
    SET_DEFAULT_TEMPLATE: '/wechat/third/admin/setDefaultTemplate',
    // 获取单个模版配置
    GET_SINGLE_TEMPLATE: '/wechat/third/admin/getTemplate',
    // 小程序体验版提交审核
    SUBMIT_AUDIT: '/wechat/third/admin/appSubmit',
    // 小程序体验版发布
    COMMIT_WEAPP: '/wechat/third/admin/appCommit',
    // 设置小程序备注
    SET_WEAPP_REMARK: '/wechat/third/admin/remark',
    // 下载小程序素材
    DownLoad_Weapp_Source: '/wechat/third/admin/downloadPermanentFile',
    // 删除小程序
    DEL_WEAPP: '/wechat/third/admin/deleteInvalidApp',
    // 更新小程序信息
    UPDATE_WEAPP: '/wechat/third/admin/syncApp',

    // 象店管理
    GET_ELESTORE_LIST: '/admin/member/store/stores/page', // 象店列表
    GET_CERT_MEMBER_LIST: '/admin/member/store/unopened-companys/page', // 未开通象店的会员列表
    ADD_ELESTORE: '/admin/member/store/add', // 添加象店
    GET_ELESTORE_MANAGER_LIST: '/admin/member/store/store-manager/page', // 店长列表
    GET_SHARE_BONUS: '/admin/member/store/platform-share-bonus', // 查询平台当前享金比例
    UPDATE_SHARE_BONUS: '/admin/member/store/platform-share-bonus/set', // 设置平台享金比例

    // 象买网-用户管理
    GET_ELEBUYS_USER_LIST: '/admin/member/company/user-list', // 用户列表
    EDIT_ELEBUYS_USER_INFO: '/admin/member/company/user/mobile-password/modify',
    GET_ELEBUYS_USER_REGISTER_LIST: '/admin/member/company/apply-registry-list', // 注册审核列表
    AUDIT_ELEBUYS_USER_REGISTER: '/admin/member/company/signup/audit', //
    GET_ELEBUYS_AUTH_LIST: '/admin/member/company/certification-infos', // 获取认证审核列表
    AUDIT_ELEBUYS_AUTH: '/admin/member/company/certification-info/audit', //
    GET_ELEBUYS_AUTH_INFO: '/admin/member/company/certification-info/by-id', //
    GET_CERT_INFO: '/admin/member/company/passed-certification-info',
    GET_USER_TAG: '/admin/member/company/user-label/query', // 获取用户标签
    SET_USER_TAG: '/admin/member/company/user-labels/set', // 设置用户标签
    GET_ELESTORES_USER_LIST: '/admin/member/company/store-user/page', // 象店用户-用户列表
    UPDATE_VIP_LEVEL: '/admin/member/company/plus-end-time/edit', // 修改会员等级
    PLUS_RECORD_LIST: '/admin/member/company/plus-end-time/log-list', // plus修改记录
    APPOINTMENT_TASK_PAGE: '/admin/member/product/member-level/appointment-task/page', // 获取预约任务分页列表
    APPOINTMENT_TASK_CANCEL: '/admin/member/product/member-level/appointment-task/cancel', // 获取预约任务分页列表
    GET_PROMOTER_LIST: '/admin/member/salesman/page', // 业务员列表
    ADD_PROMOTER: '/admin/member/salesman/create', // 添加业务员
    DELETE_PROMOTER: '/admin/member/salesman/delete', // 删除业务员
    SET_PROMOTER: '/admin/member/salesman/bind', // 设置业务员
    ADD_USER: '/admin/member/company/add-user', // 添加用户
    UPDATE_PARTNER_LEVEL: '/admin/member/company/partner-end-time/edit', // 修改合伙人等级
    GET_PARTNER_LIST: '/member/partner/queryPage', // 合伙人申请列表
    REMARK_PARTNER: '/member/partner/update', // 标记合伙人
    SEARCH_MEMBER_LEVEL: '/admin/member/company/member-level/get', //查询会员等级信息
    SEARCH_MEMBER_LEVEL_INFO: '/admin/member/product/member-level-info/query', //查询会员各等级详细信息
    CHANGE_MEMBER_LEVEL: '/admin/member/product/member-level/edit', //修改会员等级
    CHANGE_MEMBER_LEVEL_NEW: '/admin/member/product/member-level/edit/new', //修改会员等级(新)
    APPOINTMENT_TASK_CREATE: '/admin/member/product/member-level/appointment-task/create', //提前续约
    GET_MEMBER_INFO: '/admin/member/company/user', //查询会员信息
    GET_SERVICE_GROUP_DROP: '/member/service-group/dropdownList', //服务组下拉列表
    ALLOCATE_SERVICE_GROUP: '/member/service-group/allocate', //分配服务组
    GET_ELEBUYS_RECORD_LIST: '/admin/member/company-record/list-condition', // 会员档案列表
    GET_USER_RECORD_LIST: '/admin/member/company-record/query-principal', // 会员档案销售客成列表
    GET_USER_RECORD_EDIT: '/admin/member/company-record/compile', // 会员档案编辑
    GET_USER_RECORD_DETAIL: '/admin/member/company-record/details', // 会员档案详情
    GET_USER_RECORD_EXPORT: '/admin/member/company-record/user-list-export', // 会员档案列表导出
    GET_USER_TRADE_LIST: '/admin/company-trade/list', // 会员交易中心列表
    GET_USER_TRADE_CANCEL: '/admin/company-trade/cancel', // 会员交易中心作废
    GET_USER_TRADE_PAY: '/admin/company-trade/add-fee', // 会员交易中心扣费
    GET_USER_TRADE_ADD: '/admin/company-trade/add', // 会员交易中心保存
    GET_USER_COMPANY_LIST: '/admin/company-trade/company-names-in-types',//
    GET_USER_TRADE_DETAIL: '/admin/company-trade/detail', // 会员交易中心详情
    GET_MEMBER_VERSION: '/admin/member/company-record/member-version', // 会员版本
    GET_AREA_AREAS: '/basic/area/areas', // 地址、
    GET_MEMBER_USER_LIST:'/admin/member/rights/user-list',
    CHECK_PERMISSION: '/admin/member/rights/check-empty-permission', // 检查是否可增购
    

    // 象买网-商铺列表
    GET_SHOP_REVENUE_LIST: '/', //
    GET_SHOP_LIST: '/admin/member/shop/shops/page', //
    GET_SHOP_DETAIL: '/admin/member/shop/detail', //
    ADD_SHOP: '/admin/member/shop/add',
    EDIT_SHOP: '/admin/member/shop/update',
    SEARCH_SHOP_AUTH_RECORD_LIST: '/admin/member/shop/company-name',
    GET_SUPPLIER_LIST_BY_NAME: '/admin/supplier/short-names',
    // GET_SHOP_AUTH_RECORD: '/admin/member/company/certification-info',

    GET_SHOP_TYPE_LIST: '/admin/member/shop/shop-types', //
    ADD_SHOP_TYPE: '/admin/member/shop/shop-type/add', //
    EDIT_SHOP_TYPE: '/admin/member/shop/shop-type/update', //
    DEL_SHOP_TYPE: '/admin/member/shop/shop-type/delete', //

    ADD_FLOOR_INDEPEND: '/elebuys/admin/page-floor/add-topic-floor',

    CLOSE_ACCOUNT: '/admin/member/company/remove-member-lv',

    CREATE_WEBSITE_TEMP: '/admin/fleshopy/official/official-template/create', // 创建官网模板
    GET_WEBSITE_TEMP_INFO: '/admin/fleshopy/official/official-template/info', // 官网模板信息查询
    GET_WEBSITE_TEMP_LIST: '/admin/fleshopy/official/official-template/page', // 获取官网模板分页列表
    EDIT_WEBSITE_TEMP: '/admin/fleshopy/official/official-template/update', // 编辑官网模板
    DELETE_WEBSITE_TEMP: '/admin/fleshopy/official/official-template/remove', // 删除官网模板
    GET_WEBSITE_LIST: '/admin/fleshopy/official/official-site/officialSitePageOpe', // 运营端会员官网分页列表
    UPDATE_WEBSITE_LIST: '/admin/fleshopy/official/official-site/createOfficialSiteSignature', // 运营端会员官网分页列表修改
    UPDATE_WEBSITE_STATUS: '/admin/fleshopy/official/official-site/updateOfficialSiteOpeStatus', // 运营端启用或禁用官网
    
    GET_QW_LIST: '/admin/wechat/app/page', // 获取企微应用分页列表
    GET_QW_DETAIL: '/admin/wechat/app/detail', // 获取企微应用详情
    REFRESH_QW_APP: '/admin/wechat/app/refresh', // 刷新企微应用信息
  },
  // 应用市场运营
  appMarket: {
    GET_CAROUSEL_SHOW_NUMBER: '/basic/admin/app/app-carousel/getShowNumber', // 显示数量查询
    GET_CAROUSEL_LIST: '/basic/admin/app/app-carousel/pageQuery', // 轮播图列表
    ADD_CAROUSEL: '/basic/admin/app/app-carousel/add', // 添加轮播图
    UPDATE_CAROUSEL: '/basic/admin/app/app-carousel/update', // 编辑轮播图
    UPDATE_CAROUSEL_SORT: '/basic/admin/app/app-carousel/updateSort', // 修改轮播图排序
    DELETE_CAROUSEL: '/basic/admin/app/app-carousel/delete', // 删除轮播图
    UPDATE_CAROUSEL_STATUS: '/basic/admin/app/app-carousel/updateStatus', // 改变轮播图状态

    GET_ADVERT_CONFIG: '/basic/admin/app/app-advertise/getInfo', // 获取广告图信息
    ADD_ADVERT: '/basic/admin/app/app-advertise/add', // 添加广告图
    UPDATE_ADVERT: '/basic/admin/app/app-advertise/update', // 编辑广告图

    GET_CASE_LIST: '/basic/admin/app/case/queryPage', // 查询案例列表
    ADD_CASE: '/basic/admin/app/case/create', // 添加案例
    UPDATE_CASE: '/basic/admin/app/case/update', // 编辑案例
    UPDATE_CASE_SORT: '/basic/admin/app/case/updateSort', // 更改案例排序
    UPDATE_CASE_STATUS: '/basic/admin/app/case/updateStatus', // 案例状态
    DELETE_CASE: '/basic/admin/app/case/delete', // 删除案例
    GET_CASE_INFO: '/basic/admin/app/case/get', // 查询单个案例信息

    GET_CASE_TYPE_LIST: '/basic/admin/app/case/type/getAll', // 案例分类列表
    ADD_CASE_TYPE: '/basic/admin/app/case/type/add', // 添加案例分类
    UPDATE_CASE_TYPE: '/basic/admin/app/case/type/update', // 编辑案例分类
    DELETE_CASE_TYPE: '/basic/admin/app/case/type/delete', // 删除案例分类
  },
  card: {
    GET_CARD_PAGE_CONFIG: '/admin/card/block/getDetail', // 获取 应用首页/制卡页面 配置信息
    SET_CARD_PAGE_CONFIG: '/admin/card/block/add', // 设置 应用首页/制卡页面 配置信息
    SET_CARD_PAGE_CONFIG_IMG: '/admin/card/block/updateElement', // 设置 应用首页/制卡页面 配置图片

    GET_CARD_CASE_LIST: '/admin/card/case/pageQuery', // 获取卡券案例列表
    CHANGE_CARD_CASE_STATUS: '/admin/card/case/updateStatus', // 修改卡券案例状态
    CHANGE_CARD_CASE_SORT: '/admin/card/case/updateSort', // 修改卡券案例排序
    ADD_CASE: '/admin/card/case/create', // 添加卡券案例
    UPDATE_CASE: '/admin/card/case/update', // 编辑卡券案例

    ADD_CARD_TAG_TYPE: '/card/label/addType', // 添加卡券模板标签类别
    GET_CARD_TAG_TYPE_LIST: '/card/label/selectType', // 获取卡券模板标签类别列表
    GET_CARD_TAG_LIST: '/card/label/select', // 获取卡券模板标签列表
    ADD_CARD_TAG: '/card/label/addName', // 添加标签名称
    UPDATE_CARD_TAG: '/card/label/updateName', // 编辑标签名称
    DELETE_CARD_TAG: '/card/label/delName', // 删除标签
    GET_CARD_TAG_TREE_LIST: '/card/label/show', // 获取卡券标签树

    GET_CARD_COVER_LIST: '/card/cover/query', // 获取卡券封面列表
    ADD_CARD_COVER: '/card/cover/add', // 添加卡券封面
    DELETE_CARD_COVER: '/card/cover/del', // 删除卡券封面

    GET_CARD_TMPL_LIST: '/card/template/queryPage', // 获取卡券模板列表
    CHANGE_CARD_TMPL_STATUS: '/card/template/updateStatus', // 修改卡券模板上下架状态
    ADD_CARD_TMPL: '/card/template/create', // 创建卡券模板
    DELETE_CARD_TMPL: '/card/template/delete', // 删除卡券模板
    GET_CARD_TMPL_DETAIL: '/card/template/get', // 获取卡券模板详情
    UPDATE_CARD_TMPL: '/card/template/update', // 编辑卡券模板

    GET_CARD_SELECT_GOODS: '/card/template/search', // 获取商品列表-供挑选

    GET_NUMBER_CARD_TAG_LIST: '/elecard/label/v1/query/list/group', //新卡券模板标签
    GET_NUMBER_CARD_LIST_NEW: '/elecard/label/v1/query/list/page', //数字卡券模板列表
    GET_NUMBER_TAG_CATEGORY: '/elecard/label/v1/query/type', //数字卡券标签类别
    GET_NUMBER_TAG_Modal_CATEGORY: '/elecard/label/v1/setting/type', //添加标签类别
    EDIT_NUMBER_LIST: '/elecard/label/v1/setting/label', //数字卡券页面的编辑/添加标签名称
    DELETE_NUMBER_TAG_LIST: '/elecard/label/v1/delete', //删除数字卡券列表数据
    GET_CARD_EXAMINE_LIST: '/elecard/coupon/audit/v1/list', //卡券审核列表数据
    GET_CARD_EXAMINE_COUNT: '/elecard/coupon/audit/v1/statistics', //卡券审核的个数
    GET_BUMBER_COMPANY_LIST: '/elecard/coupon/audit/v1/list/es', // 获取会员名称
    GET_BUMBER_COUPON_LIST: '/elecard/coupon/audit/v1/list/es', //获取卡券名称
    GET_NUMBER_BATCH_APPROVE: '/elecard/coupon/audit/v1/approve', //批量审核
    SET_EXAMINE_REMARK: '/elecard/coupon/audit/v1/addremark', //备注
    GET_CARD_DETAIL_INFO: '/elecard/coupon/audit/v1/detail', //卡券详情
    GET_EXAMINE_NEXT: '/elecard/coupon/audit/v1/approve/next', //卡券审核下一个
    UPLOAD_BANNER_URL: 'elecard/operation/banner/v1/setting', //上传banner图片
    GET_BANNER_URL: 'elecard/operation/banner/v1/query', //获取banner图片
    GET_CARD_MODAL_LIST: '/elecard/admin/template/get', //获取卡券模板列表
    UP_DOWN_SHELF: '/elecard/admin/template/basic/update', //上下架
    CREATE_CARD_MODAL: '/elecard/admin/template/add', //创建模板
    GET_TEMPLATE_INFO: '/elecard/admin/template/getTemplateInfo', //编辑模板回显的内容
    UPDATE_TEMPLATE_INFO: '/elecard/admin/template/updateTemplateInfo',
  },
  project: {
    GET_LIST: '/procurement/track/project/getList',
    ADD_OR_EDIT_PROJECT: '/procurement/track/project/addOrUpdate',
    GET_STATISTICS_DATA: '/procurement/track/project/getData',
    OPERATE_PROJECT: '/procurement/track/project/operate',
  },

  offisetting: {
    DICT_DICTIONARIES: '/basic/dict/dictionaries',
    GET_SYSTEM_TREE: '/admin/right/menu/systemTree',
    ADD_ADMIN_RIGHT_MENU: '/admin/right/menu/add', // 添加菜单
    UP_ADMIN_RIGHT_MENU: '/admin/right/menu/update',
    GET_FORM_TPL_LIST: '/form/template/list', // 动态表单模版列表
  },
  accountRegistration: {
    ACCOUNT_REGISTRATION: '/admin/right/register/register',
    CREAT_TOKEN: '/admin/right/login/generateToken',
    ADMIN_WEB: '/admin/right/user/adminWeb/list',
    STATUS_CHANGE: '/admin/right/user/statusChange',
  },
  // API开放平台管理api
  apiManage: {
    GET_BUSINESS_INFOS: "/oauth2/operate/getBusinessInfos", //获取所有商家信息
    AUDIT_SUCCESS: "/oauth2/operate/auditSuccess", //审核通过
    UPDATE_AUTHORIZED: "/oauth2/operate/updateAuthorized", //修改访问权限
    GET_GROUP_INFOS: "/oauth2/operate/getGroupInfos", //获取所有资源信息
  },
  // 字典维护api

  loginConfiguratin: {
    GET_PELITEN_LOGIN_LIST: '/admin/member/login-page/list',
    ADD_PELITEN_LOGIN_INFO: '/admin/member/login-page/add',
    GET_PELITEN_LOGIN_INFO: '/admin/member/login-page/query',
    UPDATE_PELITEN_LOGIN_INFO: '/admin/member/login-page/update',
    DELETE_PELITEN_LOGIN_INFO: '/admin/member/login-page/delete',
  },
  dicOrder: {
    DIC_TYPE: '/admin/basic/dict/dictionary/type',
    DIC_LIST: '/admin/basic/dict/dictionary-list',
    DIC_ADD: '/admin/basic/dict/dictionary/add',
    DIC_DEL: '/admin/basic/dict/dictionary/delete',
    DIC_EDIT: '/admin/basic/dict/dictionary/update',
  },
  // API开放平台管理api
  apiManage: {
    GET_BUSINESS_INFOS: '/oauth2/operate/getBusinessInfos', //获取所有商家信息
    AUDIT_SUCCESS: '/oauth2/operate/auditSuccess', //审核通过
    UPDATE_AUTHORIZED: '/oauth2/operate/updateAuthorized', //修改访问权限
    GET_GROUP_INFOS: '/oauth2/operate/getGroupInfos', //获取所有资源信息
  },
  //挑选商品弹窗API
  goodsModal: {
    TREE_LIST: '/admin/goods/category/getTree', //分类树列表,
    JD_GOODS_LIST: '/admin/product/goods/search/getJdListShop', //京东商品列表
    // SHOP_GOODS_LIST: "/goods/facade/goods/search/mall", //象铺商品列表 //admin/goods/searchGoods/getMallGoodsListByConditions
    SHOP_GOODS_LIST: '/admin/goods/searchGoods/getMallGoodsListByConditions', //象铺商品列表 //admin/goods/searchGoods/getMallGoodsListByConditions
    SHOPNAME_LIST: '/member/shop/shops/search/v2', //商铺搜索列表 /admin/goods/searchGoods/getMall
    BRANDNAME_LIST: '/elebuys/goods/brand/getListPage', //品牌搜索列表 /admin/goods/searchGoods/getBrand
    JD_STOCK_LIST: '/admin/product/stock/getStockJdBatch', //京东商品库存数量
  },
  // 电商saas运营相关
  saas: {
    GET_SAAS_TAG_LIST: '/fleshopy/tag/tag/queryTag', // 商城、模版标签列表-分页
    GET_SAAS_ALL_TAG_LIST: '/fleshopy/tag/tag/show', // 商城、模版标签列表-全部
    GET_TAG_USE_NUM: '/fleshopy/tag/tag/queryCount', // 商城、模版标签使用次数显示
    UPDATE_SORT: '/fleshopy/tag/tag/updateSort', // 标签排序
    DELETE_TAG: '/fleshopy/tag/tag/delTag', // 删除标签
    ADD_TYPE: '/fleshopy/tag/tag-category/addType', // 添加标签类别
    EDIT_TYPE: '/fleshopy/tag/tag-category/addType', // 添加标签类别
    OPERATE_TAG: '/fleshopy/tag/tag/addOrUpdateTag', // 标签添加/编辑标签
    GET_TYPE_LIST: '/fleshopy/tag/tag-category/queryType', // 标签类别列表
    GET_TPL_LIST: '/fleshopy/admin/template/pageList', // 模版列表
    // 应用分类
    GET_CATEGORY_LIST: '/fleshopy/tag/app-class/showAppClass', // 分类列表
    UPDATE_CATEGORY_SORT: '/fleshopy/tag/app-class/updateAppSort', // 应用分类排序修改
    GET_CATEGORY_USE_NUM: '/fleshopy/tag/app-class/showUseCount', // 应用分类使用次数显示
    DELETE_CATEGORY: '/fleshopy/tag/app-class/delAppClass', // 删除分类
    OPERATE_CATEGORY: '/fleshopy/tag/app-class/addOrUpdateApp', // 分类添加/编辑
    // 模版
    ADD_TEMPLATE: '/fleshopy/admin/template/add', // 添加模版
    GET_TEMPLATE_INFO: '/fleshopy/admin/template/getDetail', // 获取模版详情
    EDIT_TEMPLATE: '/fleshopy/admin/template/updateConfig', // 编辑模版
    UP_TEMPLATE: '/fleshopy/admin/template/release', // 上架
    DOWN_TEMPLATE: '/fleshopy/admin/template/offSale', // 下架
    // 专题
    GET_SPECIAL_LIST: '/admin/fleshopy/special-topic/pageList', // 获取专题列表
    GET_SPECIAL_CHILD: '/fleshopy/admin/specialtopic/special-topic/getChildren', // 获取子专题
    ADD_SPECIAL: '/admin/fleshopy/special-topic/addTopic', // 添加专题
    ADD_CHILD_SPECIAL: '/fleshopy/admin/specialtopic/special-topic/addChildTopic', // 添加子专题
    EDIT_CHILD_SPECIAL: '/fleshopy/admin/specialtopic/special-topic/updateChildTopic', // 编辑子专题
    EDIT_SPECIAL: '/admin/fleshopy/special-topic/updateTopic', // 编辑专题
    GET_SPECIAL_PRODUCT: '/admin/fleshopy/special-topic/topicGoodsPageList', // 获取专题商品列表
    UPDATE_SPECIAL: '/admin/fleshopy/special-topic/updateStatus', // 更新专题状态 上架、下架、删除
    GET_SHOP_CAtEGORY: '/fleshopy/category/getTreeList', // 获取商品分类
    GET_PRODUCT_LIST: '/admin/fleshopy/special-topic/topicGoodsSelectPageList', // 挑选专题商品分页列表
    ADD_SPECIAL_PRODUCTS: '/admin/fleshopy/special-topic/addGoods', // 专题添加商品
    REMOVE_SPECIAL_PRODUCTS: '/admin/fleshopy/special-topic/removeGoods', // 专题移除商品
    GET_SPECIAL_PRODUCTS_COUNT: '/admin/fleshopy/special-topic/topicGoodsCountQuery', // 专题商品统计
    SPECIAL_SORT: '/fleshopy/admin/specialtopic/special-topic/updateSort', // 子专题排序
    get_site_tag: '/fleshopy/tag/tag/show', //标签
    get_tplmarket_list: '/fleshopy/admin/template/usablePageList', // 获取模版列表
    get_site_detail: '/fleshopy/merchant/site/getSite', // 获取站点信息
    get_address: '/basic/area/areas', // 获取地址
    creat_tpl_site: '/fleshopy/admin/site/addSite', // 使用模版创建站点
    copy_site: '/fleshopy/merchant/site/copySite', // 复制站点
    GET_SUPPLIER_LIST_BY_NAME: '/admin/member/company/company-list/by-name', // 供应商简称列表
    GET_VIP_SHOW: '/fleshopy/admin/site/toggleSiteMemberCanSee', //VIP站点显示
    GET_SITE_LIST: '/fleshopy/admin/site/siteList', //条件查询站点列表
    GET_YUNYING_TOKEN: '/admin/right/login/agentLogin', //(客户站点管理)把运营端token传过去获取新token
    GET_YUNYING_TOKEN_MANAGE: '/admin/right/login/syncLogin', //(站点模板)把运营端token传过去获取新token
    GET_SITE_INFO: '/fleshopy/admin/site/getSite', //详情获取站点信息
    GET_COMPANY_LIST: '/admin/member/company/company-list/by-account', //根据企业名称模糊查询合伙人列表
    GET_SHOP_COMPANY_LIST: '/member/company/company-list/by-name',
    GET_CHECK_CREATE: '/fleshopy/admin/site/checkCreateMarketingAccount', //会员账号查看建站资格
    GET_SPEED_INFO: '/fleshopy/admin/site/site-goods/getPickGoodsToSiteStatus', //站点成功也的进度信息
    GET_XIANG_SHOP_LIST_BY_NAME: '/admin/member/shop/shops/search/v2', // 象铺列表
    GET_SPECIAL_DETAIL: '/admin/fleshopy/special-topic/selectTopic', //专题详情
    // GET_SPECIAL_STOCK: "/goods/facade/goods/stock/getStockBatch", //获取京东库存
    GET_SPECIAL_STOCK: '/admin/goods/goods/stock/getStockBatch', //获取京东库存
    GET_BRAND_LIST_BY_KEYWORD: '/admin/goods/brand/getListPage', //品牌列表
  },
  selectModal: {
    GET_SELECT_SPECIAL_LIST: '/admin/fleshopy/special-topic/selectTopicForFloor', //专题列表
  },
  //修改会员账号
  amendMemberAccount: {
    GET_LIST: '/admin/member/company/user-list',
    EDIT_ACCOUNT_UPDATE: '/admin/member/company/account/update'
  },
  // 索引管理
  indexManage: {
    CREATE_INDEX: '/alchemist/index/create',
    DELETE_INDEX: '/alchemist/index/delete',
    REBUILD_INDEX: '/alchemist/index/rebuild'
  },
  // 卡券电商
  cardBase: {
    GET_CARD_PAGE_CONFIG: '/admin/card/block/getDetail', // 获取 应用首页/制卡页面 配置信息
    CARD_STORK_GETILIST: '/elecard/simpleCard/card-stock/getList', // 模版列表
    CARD_STORK_CREATE: '/elecard/simpleCard/card-stock/add', // create模版
    CARD_STORK_EDIT: '/elecard/simpleCard/card-stock/update', // edit模版
    getStockList: '/elecard/simpleCard/makingCards/inventories', // 卡券库存 - 卡券查询 列表
    createCardCoupon: '/elecard/simpleCard/makingCards/making', // 卡券库存 - 制作卡券
    getCouponList: '/elecard/simpleCard/makingCards/inventoryDetails', // 卡券库存 - 查看卡号
    exportStock: '/elecard/simpleCard/makingCards/inventory/export', // 卡券库存 - 导出明细
    exportStreamMake: '/elecard/simpleCard/couponFlow/making/export', // 制作卡券 - 导出明细
    exportStreamSale: '/elecard/simpleCard/couponFlow/sales/export', // 销售卡券 - 导出明细
    getCardTemList: '/elecard/simpleCard/card-stock/getList', // 卡券库存 - 制卡 - 选择卡弹窗
    getMakeCouponStreamList: '/elecard/simpleCard/couponFlow/making/list', // 卡券流水 - 制作卡券
    getSaleCouponStreamList: '/elecard/simpleCard/couponFlow/sales/list', // 卡券流水 - 销售卡券
    CARD_STORK_GETINFO: '/elecard/simpleCard/card-stock/getInfo', // 模版详情
    CARD_STORK_DELETE: '/elecard/simpleCard/card-stock/delete', // 删除模版
    CARD_STORK_UPDATE_STATE: '/elecard/simpleCard/card-stock/updateState', // 上架和下架
    GET_GROUP: '/elecard/label/v1/query/list/group', // 获取标签
    GET_BANNER: '/elecard/simple-card/banner-config/page', // 获取banner  
    AGENTLOGIN: '/admin/right/login/agentLogin', // 获取banner  
    SAVEBANNER: '/elecard/simple-card/banner-config/save', // 保存banner  
    getCardOrderList: '/elecard/simpleCard/card-order/admin/page', // 卡券订单列表
    getCardOrderStatusCount: '/elecard/simpleCard/card-order/admin/status/count', // 卡券订单状态统计
    getCompanyList: '/admin/member/company/company-names', // 模糊查询会员列表
    getCardOrderDetail: '/elecard/simpleCard/card-order/admin/detail', // 卡券订单详情
    changeCardOrderPrice: '/elecard/simpleCard/card-order/price/change', // 卡券订单改价
    setCardOrderRemark: '/elecard/simpleCard/card-order/seller/remark/set', // 设置卡券订单备注
    getCardOrderRemark: '/elecard/simpleCard/card-order/seller/remark/get', // 获取卡券订单备注
    pickCard: '/elecard/simpleCard/card-order/pick', // 拣货
    deliverCardOrder: '/elecard/simpleCard/card-order/delivery', // 发货
    getExpressList: '/basic/express/list', // 物流公司列表
    exportOrderCard: '/elecard/simpleCard/couponFlow/order/export', // 订单列表下载文件
    getExpressDetail: '/elecard/simpleCard/card-order/express/query', // 查看物流
  },

  // 索引管理
  eqxiu: {
    Authrozation: '/fleshopy/eqx/auth/silent-login',
    Code: '/fleshopy/eqx/auth/code',
    Token: '/fleshopy/eqx/auth/token',
    SecretId: '/fleshopy/eqx/auth/secret-id',
    AcList:'/fleshopy/eqx/creation/admin/page',
    publish:'/fleshopy/eqx/creation/publish',
    pause:'/fleshopy/eqx/creation/pause',
    resume:'/fleshopy/eqx/creation/resume',
    delete:'/fleshopy/eqx/creation/delete',
    userList:'/fleshopy/eqx/company-open-info/company/page',
    enable:'/fleshopy/eqx/company-open-info/company/enable',
    disable:'/fleshopy/eqx/company-open-info/company/disable',
    staffList:'/fleshopy/eqx/open-info/employee/page',
    staffEnable:'/fleshopy/eqx/open-info/employee/enable',
    staffDisable:'/fleshopy/eqx/open-info/employee/disable',
    preview:'/fleshopy/eqx/creation/preview-info',
    setPreview: '/fleshopy/eqx/creation/admin/share/set'
  },

}

export const mallManagementMap = new Map([
  [
    'TAGS', '/fleshopy/tag/tag/show'
  ],
  [
    'LIST',
    '/fleshopy/admin/site/cardSiteList'
  ]
]);






export default api
